import { useAuthStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";

const usePasswordUpdate = (): (currentPassword: string, newPassword: string) => Promise<void> => {
    const authStore = useAuthStore();

    return async (currentPassword: string, newPassword: string): Promise<void> => {
        if (!currentPassword || !newPassword)
            throw new Error("There are validation errors.");

        try {
            await authStore.changePassword(currentPassword, newPassword);
            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default usePasswordUpdate;